import { render, staticRenderFns } from "./InquiryIncomePopup.vue?vue&type=template&id=61e4d567&"
import script from "./InquiryIncomePopup.vue?vue&type=script&lang=js&"
export * from "./InquiryIncomePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports